import { Component, Input, inject } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { FormsModule, NgForm } from '@angular/forms';
import { DataService } from '../../../services/data.service';
import { Router } from '@angular/router';

// interface Contact {
//   name: string;
//   designation: string;
//   department: string;
//   mobile: string;
//   alternateMobile: string;
//   email: string;
//   primary: boolean;
// }

@Component({
  selector: 'app-kyc-wizard',
  standalone: true,
  imports: [CommonModule, FormsModule],
  providers: [DatePipe],
  templateUrl: './kyc-wizard.component.html',
  styleUrls: ['./kyc-wizard.component.scss']
})
export class KycWizardComponent {
  @Input() view: any;

  datePipe = inject(DatePipe);
  currentDate: Date = new Date();
  submitted = false;
  currentStep = 0;
  loading = false;
  steps = [
    'Institute',
    'Contacts',
    'Billing',
    'Organization',
    'Package',
    'Review'
  ];

  pricing: any = {
    baseAmount: 0,
    discountAmount: 0,
    subtotal: 0,
    taxAmount: 0,
    totalAmount: 0
  };

  doneModules: string = '';
  showPreview = false;
  billingCycle: string = 'annually';
  studentCount = 100;
  couponCode = '';
  appliedCoupon: any = null;
  couponValid = false;
  selectedModules: any = [];
  modules: any = [];

  formData = {
    institute: {
      org_id: '', 
      inst_code: '', 
      inst_name: '', 
      inst_type: '', 
      website: '', 
      reg_no: '', 
      gst_no: '', 
      phone_no: '', 
      address: '', 
      city: '', 
      state: '', 
      pincode: '', 
      country: '', 
      logo: '', 
      banner: '', 
      agr_consent: false,
      agr_name: '',
      agr_desi: '',
      agr_lickey: '',
      reg_date: this.datePipe.transform(this.currentDate, 'yyyy-MM-dd'), 
      is_active: true,
      district: ''
    },

    contacts: [
      {
        person_name: '', 
        person_desi: 'erp', 
        department: '', 
        mobile_no1: '', 
        mobile_no2: '', 
        email_id: '', 
        is_primary: false, 
        is_active: true
      }, {
        person_name: '', 
        person_desi: 'chm', 
        department: '', 
        mobile_no1: '', 
        mobile_no2: '', 
        email_id: '', 
        is_primary: false, 
        is_active: true
      }, {
        person_name: '', 
        person_desi: 'ppl', 
        department: '', 
        mobile_no1: '', 
        mobile_no2: '', 
        email_id: '', 
        is_primary: false, 
        is_active: true
      }, {
        person_name: '', 
        person_desi: 'acc', 
        department: '', 
        mobile_no1: '', 
        mobile_no2: '', 
        email_id: '', 
        is_primary: false, 
        is_active: true
      }
    ],

    billing: {
      billing_name: '', 
      gst_no: '', 
      gst_state_code: '', 
      address: '', 
      city: '', 
      state: '', 
      pincode: '', 
      reg_date: this.datePipe.transform(this.currentDate, 'yyyy-MM-dd'), 
      is_active: true,
      district: ''
    },

    organization: {
      org_code: '', 
      org_name: '', 
      org_address: '', 
      org_city: '', 
      org_state: '',
      org_pincode: '', 
      reg_date: this.datePipe.transform(this.currentDate, 'yyyy-MM-dd'), 
      is_active: true,
      org_exists: false,
      district: ''
    },

    package: {
      pkg_code: '',
      bill_cycle: '', 
      std_counts: '', 
      imp_amount_ot: 0.00, 
      pkg_amount: 0.00, 
      base_amount: 0.00, 
      module_amount: 0.00, 
      discount_amount: 0.00, 
      net_amount: 0.00, 
      tax_amount: 0.00, 
      total_amount: 0.00, 
      paid_amount: 0.00, 
      bal_amount: 0.00, 
      coupon_code: '', 
      paid_offline: true, 
      pay_date: '',
      start_date: '', 
      exp_date: '', 
      selected_modules: [],
      auto_renew: false, 
      save_paym: false, 
      is_active: true
    },

    agreement: {
      consent: false,
      name: '',
      designation: '',
      cur_date: new Date().toISOString().split('T')[0]
    }
  };

  // contacts: Contact[] = [
  //   {
  //     name: '',
  //     designation: '',
  //     department: '',
  //     mobile: '',
  //     alternateMobile: '',
  //     email: '',
  //     primary: true
  //   }
  // ];

  constructor(public dataService: DataService, private router: Router) {
    //
  }

  ngOnInit() {
    let erp_rem: any = localStorage.getItem("erp_rem");
    let kycData: any = localStorage.getItem('kycData');

    if(kycData) {
      kycData = JSON.parse(kycData);

      this.formData.institute = kycData?.institute || this.formData.institute;
      this.formData.contacts = kycData?.contacts || this.formData.contacts || [];
      this.formData.billing = kycData?.billing || this.formData.billing;
      this.formData.organization = kycData?.organization || this.formData.organization;
      this.formData.package = kycData?.package || this.formData.package;
    } else {
      this.loading = true;
      this.dataService.getAllRecords('kyc').then((res: any) => {
        kycData = res[0] || res;    //JSON.parse(kycData);

        if(kycData.institute && typeof kycData.institute == 'string') {
          this.formData.institute = this.dataService.str2json(kycData.institute)[0];
        } else {
          this.formData.institute = kycData.institute[0] || kycData.institute;
        }
        if(kycData.contacts && typeof kycData.contacts == 'string') {
          this.formData.contacts = this.dataService.str2json(kycData.contacts);
        } else {
          this.formData.contacts = kycData.contacts || [];
        }
        if(kycData.billing && typeof kycData.billing == 'string') {
          this.formData.billing = this.dataService.str2json(kycData.billing)[0];
        } else {
          this.formData.billing = kycData.billing[0] || kycData.billing;
        }
        if(kycData.organization && typeof kycData.organization == 'string') {
          this.formData.organization = this.dataService.str2json(kycData.organization)[0];
        } else {
          if(kycData.organization) {
            this.formData.organization = kycData.organization[0] || kycData.organization;
          }
        }
        if(kycData.package && typeof kycData.package == 'string') {
          this.formData.package = this.dataService.str2json(kycData.package)[0];
        } else {
          this.formData.package = kycData.package[0] || kycData.package;
        }

        this.loading = false;
      });
    }

    if(erp_rem) {
      erp_rem = JSON.parse(erp_rem);
      erp_rem = this.dataService.deCodeUser(erp_rem);
    }

    const myid = erp_rem.id;
    this.dataService.getSingleRecord('users', myid).then((res: any) => {
      if(res && res.kyc_data && res.kyc_data.length) {
        this.formData = JSON.parse(res.kyc_data[0]);
      }
    });

		this.loading = true;
    this.dataService.getAllRecords('modules').then((res: any) => {
      this.modules = res;
      this.loading = false;
    });
  }

  nextStep(form?: NgForm) {
    // if (form && !form.valid) {
    //   form.control.markAllAsTouched();
    //   return;
    // }

    this.doneModules = '';

    if(this.currentStep==1) {
      this.formData.billing.billing_name = this.formData.institute.inst_name;
      this.formData.billing.address = this.formData.institute.address;
      this.formData.billing.state = this.formData.institute.state;
      this.formData.billing.district = this.formData.institute.district;
      this.formData.billing.city = this.formData.institute.city;
      this.formData.billing.pincode = this.formData.institute.pincode;
    } else if(this.currentStep==3) {
      this.formData.package.pkg_code = 'p4';
      this.doneModules = 'open';
      this.updatePackagePrice();
    }

    localStorage.setItem('kycData', JSON.stringify(this.formData));

    if (this.currentStep < this.steps.length - 1) {
      this.currentStep++;
    }
  }

  previousStep() {
    if (this.currentStep > 0) {
      this.currentStep--;
    }
  }

  goToStep(index: number) {
    if (index <= this.currentStep) {
      this.currentStep = index;
    }
  }

  addContact() {
    this.formData.contacts.push({
      person_name: '', 
      person_desi: '', 
      department: '', 
      mobile_no1: '', 
      mobile_no2: '', 
      email_id: '', 
      is_primary: false, 
      is_active: true
    });
  }

  removeContact(index: number) {
    if (this.formData.contacts.length > 1) {
      this.formData.contacts.splice(index, 1);
    }
  }

  goBack() {
    this.router.navigate(['/dashboard/'+this.dataService.myEncrypt('trial')]);
  }

  setPrimary(index: number) {
    this.formData.contacts.forEach((c: any, i: any) => {
      c.primary = i === index;
    });
  }

  getProgress(): number {
    return Math.trunc(((this.currentStep + 1) / this.steps.length) * 100);
  }

  isStepCompletedX(step: number) {
    const tf: boolean = this.isStepCompleted(step);
    return tf;
  }

  isStepCompleted(step: number): boolean {
    switch(step){
      case 1:
        return !!this.formData.institute.inst_name &&
        !!this.formData.institute.inst_type &&
        !!this.formData.institute.phone_no &&
        !!this.formData.institute.address &&
        !!this.formData.institute.state &&
        !!this.formData.institute.city;

      case 2:
        // const reqDesi: any = ["erp", "chm", "ppl", "acc"];
        let reqDesi: any = ["erp"];
        return !!this.formData.contacts && 
          (this.formData.contacts[0] && this.formData.contacts[0].person_name && 
          this.formData.contacts[0].person_desi && this.formData.contacts[0].mobile_no1) &&
          // (this.formData.contacts[1] && this.formData.contacts[1].person_name && 
          // this.formData.contacts[1].person_desi && this.formData.contacts[1].mobile_no1) &&
          // (this.formData.contacts[2] && this.formData.contacts[2].person_name && 
          // this.formData.contacts[2].person_desi && this.formData.contacts[2].mobile_no1) &&
          // (this.formData.contacts[3] && this.formData.contacts[3].person_name && 
          // this.formData.contacts[3].person_desi && this.formData.contacts[3].mobile_no1) &&
          // this.formData.contacts.length > 3 &&
          // reqDesi.includes(this.formData.contacts[0].person_desi) && 
          // reqDesi.includes(this.formData.contacts[1].person_desi) && 
          // reqDesi.includes(this.formData.contacts[2].person_desi) && 
          // reqDesi.includes(this.formData.contacts[3].person_desi);
          reqDesi.includes(this.formData.contacts[0].person_desi);

      case 3:
        return !!this.formData.billing.billing_name &&
        !!this.formData.billing.address &&
        !!this.formData.billing.state &&
        !!this.formData.billing.city;

      case 4:
        return !!this.formData.organization.org_name;

      case 5:
        return !!this.formData.package.pkg_code;

      case 6:
        return !!this.submitted;

      default:
        return false;
    }
  }

  updatePackagePrice() {
    const pkg = this.formData.package.pkg_code;
    const type = this.formData.package.bill_cycle;
    let amount = 0;

    if(pkg === 'p1') {
      amount = 1500;
    } else if(pkg === 'p2') {
      amount = 1800;
    } else if(pkg === 'p3') {
      amount = 4000;
    } else if(pkg === 'p4') {
      amount = 500;
    }

    if(type === 'Quarterly') {
      amount *= 3;
    } else if(type === 'Semi Annually') {
      amount *= 6;
      // amount *= 0.9;
    } else if(type === 'Annually') {
      amount *= 12;
      // amount *= 0.9;
    }
    this.formData.package.selected_modules = this.selectedModules;
    const matchedResults = this.modules.filter((item: any) => this.selectedModules.includes(item.code));
    console.log(matchedResults);
    let selectedPrice = 0;

    if(this.formData.package.bill_cycle == "Monthly") {
      selectedPrice = matchedResults.reduce((sum: number, item: any) => {
        return sum + parseFloat(item.m_price || 0);
      }, 0);
    } else if(this.formData.package.bill_cycle == "Quarterly") {
      selectedPrice = matchedResults.reduce((sum: number, item: any) => {
        return sum + parseFloat(item.q_price || 0);
      }, 0);
    } else if(this.formData.package.bill_cycle == "Semi Annually") {
      selectedPrice = matchedResults.reduce((sum: number, item: any) => {
        return sum + parseFloat(item.h_price || 0);
      }, 0);
    } else if(this.formData.package.bill_cycle == "Annually") {
      selectedPrice = matchedResults.reduce((sum: number, item: any) => {
        return sum + parseFloat(item.a_price || 0);
      }, 0);
    }
    console.log(selectedPrice);
    this.formData.package.base_amount = amount;
    this.formData.package.module_amount = (selectedPrice * parseInt(this.formData.package.std_counts));
    this.formData.package.net_amount = amount + (selectedPrice * parseInt(this.formData.package.std_counts));
    this.formData.package.tax_amount = this.formData.package.net_amount * 0.18;   //18% GST
    this.formData.package.total_amount = this.formData.package.net_amount + this.formData.package.tax_amount;
  }

  calculateExpiry() {
    const startDate = new Date(this.formData.package.start_date);

    if (!startDate) return;

    const expiry = new Date(startDate);

    switch (this.formData.package.bill_cycle) {
      case 'Monthly':
        expiry.setMonth(expiry.getMonth() + 1);
        break;

      case 'Quarterly':
        expiry.setMonth(expiry.getMonth() + 3);
        break;

      case 'Annually':
        expiry.setFullYear(expiry.getFullYear() + 1);
        break;
    }

    this.formData.package.exp_date =
      expiry.toISOString().split('T')[0];
  }

  paymentClick() {
    if(!this.formData.package.paid_offline) {
      this.router.navigate(['/dashboard/'+this.dataService.myEncrypt('kycpay')]);
    }
  }

  submitKYC() {
    let myid = 0;
    let erp_rem: any = localStorage.getItem("erp_rem");
    if(erp_rem) {
      erp_rem = JSON.parse(erp_rem);
      erp_rem = this.dataService.deCodeUser(erp_rem);
      myid = erp_rem.id;
    }

    let kyc_form: any = {
      user_id: myid, 
      institute: this.formData.institute, 
      contacts: this.formData.contacts, 
      billing: this.formData.billing, 
      organization: this.formData.organization, 
      pkg_info: this.formData.package, 
      agreement: this.formData.agreement
    }

    this.loading = true;
    this.dataService.addNewRecord('kyc', kyc_form, true).subscribe({
      next: (response) => {
        this.submitted = true;
        this.currentStep++;
        this.loading = false;
      },
      error: (error) => {
        console.error('Error received in component:', error);
        this.loading = false;
      }
    });
  }

  // async validateCoupon(): Promise<void> {
  validateCoupon() {
    // if (!this.couponCode) {
    //   this.appliedCoupon.set(null);
    //   this.couponValid.set(null);
    //   this.calculatePricing();
    //   return;
    // }

    // const { data, error } = await supabase
    //   .from('coupons')
    //   .select('*')
    //   .eq('coupon_code', this.couponCode.toUpperCase())
    //   .eq('status', 'active')
    //   .lte('valid_from', new Date().toISOString().split('T')[0])
    //   .gte('valid_until', new Date().toISOString().split('T')[0])
    //   .single();

    // if (data && !error) {
    //   if (data.max_uses && data.used_count >= data.max_uses) {
    //     this.couponValid.set(false);
    //   } else {
    //     this.appliedCoupon.set(data);
    //     this.couponValid.set(true);
    //   }
    // } else {
    //   this.appliedCoupon.set(null);
    //   this.couponValid.set(false);
    // }

    // this.calculatePricing();
  }

  // toggleModule(code: string): void {
  toggleModule(code: string) {
    const current = [...this.selectedModules];
    const idx = current.indexOf(code);
    if (idx > -1) current.splice(idx, 1);
    else current.push(code);
    this.selectedModules = current;
    this.calculatePricing();
  }

  // async calculatePricing(): Promise<void> {
  calculatePricing() {
    // const result = await this.subService.calculatePricingFromDB(
    //   this.selectedModules(),
    //   this.studentCount,
    //   this.billingCycle
    // );

    // if (result.data) {
    //   let pricing = { ...result.data };

    //   // Apply coupon discount
    //   if (this.appliedCoupon()) {
    //     let discount = 0;
    //     if (this.appliedCoupon().discount_type === 'percentage') {
    //       discount = pricing.baseAmount * (this.appliedCoupon().discount_value / 100);
    //     } else {
    //       discount = this.appliedCoupon().discount_value;
    //     }
    //     pricing.discountAmount = Math.min(discount, pricing.baseAmount);
    //     pricing.subtotal = pricing.baseAmount - pricing.discountAmount + pricing.configurationCharge + pricing.trainingCharge;
    //     pricing.taxAmount = pricing.subtotal * 0.18;
    //     pricing.totalAmount = pricing.subtotal + pricing.taxAmount;
    //   }

    //   this.pricing.set(pricing);
    // }
  }

  isTermsValid(): boolean {
    return !!(
      this.formData?.agreement?.name &&
      this.formData?.agreement?.designation &&
      this.formData?.agreement?.cur_date &&
      this.formData?.agreement?.consent
    );
  }

}